<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center">Essays in Humanism</h1>
<h3 class="center" style="margin-top:60px;">Albert Einstein</h3>
<h3 class="center" style="margin-top:60px;"></h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="images/phil_01.jpg" width="20%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4d8de356